import { render, staticRenderFns } from "./ManterProcurador.vue?vue&type=template&id=2f39b3de&scoped=true&"
import script from "./ManterProcurador.vue?vue&type=script&lang=js&"
export * from "./ManterProcurador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f39b3de",
  null
  
)

export default component.exports